<template>
    <div class="edc-mobile-nav-helper"></div>
    <nav class="edc-mobile-nav">
        <div class="content">
            <router-link class="nav-item" :to="{ name: 'home' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M6.875 19H9.875V14C9.875 13.7167 9.971 13.479 10.163 13.287C10.355 13.095 10.5923 12.9993 10.875 13H14.875C15.1583 13 15.396 13.096 15.588 13.288C15.78 13.48 15.8757 13.7173 15.875 14V19H18.875V10L12.875 5.5L6.875 10V19ZM4.875 19V10C4.875 9.68333 4.946 9.38333 5.088 9.1C5.23 8.81667 5.42567 8.58333 5.675 8.4L11.675 3.9C12.025 3.63333 12.425 3.5 12.875 3.5C13.325 3.5 13.725 3.63333 14.075 3.9L20.075 8.4C20.325 8.58333 20.521 8.81667 20.663 9.1C20.805 9.38333 20.8757 9.68333 20.875 10V19C20.875 19.55 20.679 20.021 20.287 20.413C19.895 20.805 19.4243 21.0007 18.875 21H14.875C14.5917 21 14.354 20.904 14.162 20.712C13.97 20.52 13.8743 20.2827 13.875 20V15H11.875V20C11.875 20.2833 11.779 20.521 11.587 20.713C11.395 20.905 11.1577 21.0007 10.875 21H6.875C6.325 21 5.854 20.804 5.462 20.412C5.07 20.02 4.87434 19.5493 4.875 19Z" />
                </svg>
                <p class="label">Inicio</p>
            </router-link>
            <router-link class="nav-item" :to="{ name: 'play' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M10.125 16.5L17.125 12L10.125 7.5V16.5ZM12.625 22C11.2417 22 9.94167 21.7373 8.725 21.212C7.50833 20.6867 6.45 19.9743 5.55 19.075C4.65 18.175 3.93767 17.1167 3.413 15.9C2.88833 14.6833 2.62567 13.3833 2.625 12C2.625 10.6167 2.88767 9.31667 3.413 8.1C3.93833 6.88333 4.65067 5.825 5.55 4.925C6.45 4.025 7.50833 3.31267 8.725 2.788C9.94167 2.26333 11.2417 2.00067 12.625 2C14.0083 2 15.3083 2.26267 16.525 2.788C17.7417 3.31333 18.8 4.02567 19.7 4.925C20.6 5.825 21.3127 6.88333 21.838 8.1C22.3633 9.31667 22.6257 10.6167 22.625 12C22.625 13.3833 22.3623 14.6833 21.837 15.9C21.3117 17.1167 20.5993 18.175 19.7 19.075C18.8 19.975 17.7417 20.6877 16.525 21.213C15.3083 21.7383 14.0083 22.0007 12.625 22ZM12.625 20C14.8583 20 16.75 19.225 18.3 17.675C19.85 16.125 20.625 14.2333 20.625 12C20.625 9.76667 19.85 7.875 18.3 6.325C16.75 4.775 14.8583 4 12.625 4C10.3917 4 8.5 4.775 6.95 6.325C5.4 7.875 4.625 9.76667 4.625 12C4.625 14.2333 5.4 16.125 6.95 17.675C8.5 19.225 10.3917 20 12.625 20Z" />
                </svg>
                <p class="label">Dale play</p>
            </router-link>
            <router-link class="nav-item" :to="{ name: 'businesses' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M21.4001 11.05V19C21.4001 19.55 21.2044 20.021 20.8131 20.413C20.4217 20.805 19.9507 21.0007 19.4001 21H5.40006C4.85006 21 4.37906 20.804 3.98706 20.412C3.59506 20.02 3.39972 19.5493 3.40106 19V11.05C3.01772 10.7 2.72206 10.25 2.51406 9.7C2.30606 9.15 2.30172 8.55 2.50106 7.9L3.55106 4.5C3.68439 4.06667 3.92206 3.70833 4.26406 3.425C4.60606 3.14167 5.00106 3 5.44906 3H19.3491C19.7991 3 20.1907 3.13767 20.5241 3.413C20.8574 3.68833 21.0991 4.05067 21.2491 4.5L22.2991 7.9C22.4991 8.55 22.4951 9.14167 22.2871 9.675C22.0791 10.2083 21.7841 10.6667 21.4001 11.05ZM14.6001 10C15.0501 10 15.3917 9.84567 15.6251 9.537C15.8584 9.22833 15.9501 8.88267 15.9001 8.5L15.3501 5H13.4001V8.7C13.4001 9.05 13.5167 9.35433 13.7501 9.613C13.9834 9.87167 14.2667 10.0007 14.6001 10ZM10.1001 10C10.4834 10 10.7961 9.87067 11.0381 9.612C11.2801 9.35333 11.4007 9.04933 11.4001 8.7V5H9.45006L8.90005 8.5C8.83339 8.9 8.92072 9.25 9.16206 9.55C9.40339 9.85 9.71606 10 10.1001 10ZM5.65006 10C5.95006 10 6.21272 9.89167 6.43806 9.675C6.66339 9.45833 6.80072 9.18333 6.85006 8.85L7.40006 5H5.45006L4.45006 8.35C4.35006 8.68333 4.40439 9.04167 4.61306 9.425C4.82172 9.80833 5.16739 10 5.65006 10ZM19.1501 10C19.6334 10 19.9834 9.80833 20.2001 9.425C20.4167 9.04167 20.4667 8.68333 20.3501 8.35L19.3001 5H17.4001L17.9501 8.85C18.0001 9.18333 18.1377 9.45833 18.3631 9.675C18.5884 9.89167 18.8507 10 19.1501 10ZM5.40006 19H19.4001V11.95C19.3167 11.9833 19.2627 12 19.2381 12H19.1501C18.7001 12 18.3044 11.925 17.9631 11.775C17.6217 11.625 17.2841 11.3833 16.9501 11.05C16.6501 11.35 16.3084 11.5833 15.9251 11.75C15.5417 11.9167 15.1334 12 14.7001 12C14.2501 12 13.8291 11.9167 13.4371 11.75C13.0451 11.5833 12.6994 11.35 12.4001 11.05C12.1167 11.35 11.7874 11.5833 11.4121 11.75C11.0367 11.9167 10.6327 12 10.2001 12C9.71672 12 9.27939 11.9167 8.88805 11.75C8.49672 11.5833 8.15072 11.35 7.85006 11.05C7.50006 11.4 7.15439 11.646 6.81306 11.788C6.47172 11.93 6.08372 12.0007 5.64906 12H5.53606C5.49472 12 5.44906 11.9833 5.39906 11.95L5.40006 19Z" />
                </svg>
                <p class="label">Negocios</p>
            </router-link>
            <router-link class="nav-item" :to="{ name: 'account' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M12.125 12C11.025 12 10.0833 11.6083 9.3 10.825C8.51667 10.0417 8.125 9.1 8.125 8C8.125 6.9 8.51667 5.95833 9.3 5.175C10.0833 4.39167 11.025 4 12.125 4C13.225 4 14.1667 4.39167 14.95 5.175C15.7333 5.95833 16.125 6.9 16.125 8C16.125 9.1 15.7333 10.0417 14.95 10.825C14.1667 11.6083 13.225 12 12.125 12ZM4.125 18V17.2C4.125 16.6333 4.271 16.1123 4.563 15.637C4.855 15.1617 5.24233 14.7993 5.725 14.55C6.75833 14.0333 7.80834 13.6457 8.875 13.387C9.94167 13.1283 11.025 12.9993 12.125 13C13.225 13 14.3083 13.1293 15.375 13.388C16.4417 13.6467 17.4917 14.034 18.525 14.55C19.0083 14.8 19.396 15.1627 19.688 15.638C19.98 16.1133 20.1257 16.634 20.125 17.2V18C20.125 18.55 19.929 19.021 19.537 19.413C19.145 19.805 18.6743 20.0007 18.125 20H6.125C5.575 20 5.104 19.804 4.712 19.412C4.32 19.02 4.12434 18.5493 4.125 18ZM6.125 18H18.125V17.2C18.125 17.0167 18.079 16.85 17.987 16.7C17.895 16.55 17.7743 16.4333 17.625 16.35C16.725 15.9 15.8167 15.5627 14.9 15.338C13.9833 15.1133 13.0583 15.0007 12.125 15C11.1917 15 10.2667 15.1127 9.35 15.338C8.43334 15.5633 7.525 15.9007 6.625 16.35C6.475 16.4333 6.354 16.55 6.262 16.7C6.17 16.85 6.12434 17.0167 6.125 17.2V18ZM12.125 10C12.675 10 13.146 9.804 13.538 9.412C13.93 9.02 14.1257 8.54933 14.125 8C14.125 7.45 13.929 6.979 13.537 6.587C13.145 6.195 12.6743 5.99933 12.125 6C11.575 6 11.104 6.196 10.712 6.588C10.32 6.98 10.1243 7.45067 10.125 8C10.125 8.55 10.321 9.021 10.713 9.413C11.105 9.805 11.5757 10.0007 12.125 10Z" />
                </svg>
                <p class="label">Mi cuenta</p>
            </router-link>
        </div>
    </nav>
</template>

<script>
export default {
    name: "edc-mobile-nav"
}
</script>

<style scoped>
.edc-mobile-nav-helper {
    height: 72px;
}
.edc-mobile-nav {
    width: 100%;
    height: 72px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    box-shadow: 0px -4px 12px 0px rgba(0, 0, 0, 0.10);
    z-index: 9;
}

.edc-mobile-nav .content {
    width: 100%;
    height: 100%;
    max-width: 500px;
    display: flex;
    justify-content: center;
}

.nav-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-decoration: none;
    color: var(--color-dark);
    fill: var(--color-dark);
}

.nav-item.router-link-active {
    background-color: rgba(161, 83, 170, 0.1);
    fill: var(--color-primary);
    color: var(--color-primary);
    font-weight: bold;
}

.nav-item svg {
    fill: inherit;
}

.nav-item .label {
    text-decoration: none;
    color: inherit;
    font-size: 14px;
}

@media (min-width: 920px) {
    .edc-mobile-nav { display: none }
    .edc-mobile-nav-helper { display: none }
}
</style>